<template>
    <div class="wrapper">
        <textarea
            multi-line
            ref="ueditor"
            class="editor"
            :class="{
                editable: !readonly,
                codemode: codemode
            }"
            :placeholder="placeholder"
            :readonly="readonly"
            :maxlength="maxlength"
            :value="value"
            @input="onChange"
        />
    </div>
</template>

<script>
export default {
  mounted () {
    this.autosize()
  },

  props: {
    value: String,
    placeholder: String,
    maxlength: Number,

    codemode: {
      type: Boolean,
      default: false
    },

    readonly: {
      type: Boolean,
      default: false
    }
  },

  watch: {
    value () {
      this.$nextTick(() => {
        this.autosize()
      })
    }
  },

  methods: {
    onChange (evt) {
      this.$emit('input', evt.target.value)
    },

    autosize () {
      this.$refs.ueditor.style.height = 'auto'
      const h = this.$refs.ueditor.scrollHeight
      if (h !== 0) this.$refs.ueditor.style.height = `${h}px`
    }
  }
}
</script>

<style lang="scss" scoped>
    .wrapper {
        display: flex;
        flex-grow: 1;

        .editor {
            width: 100%;
            min-height: 20px;
            line-height: 1.5;
            border: none;
            outline: none;
            color: $or-black-blue;
            font-size: 14px;
            font-weight: normal;
            resize: none;
            padding: 0;

            &.editable {
                color: $or-black-blue;
            }

            &.codemode {
                font-family: 'Courier New', Courier, monospace;
                color: $or-grey-dark;
                font-weight: bold;
            }
        }
    }
</style>
